<template>
  <div class="widget white_box">
    <div class="widget_header">
      <div class="location_tag">
        <h3 class="heading">
          Incorrect Citations
        </h3>
        <div class="sub_heading">
          Location: {{ selectedLocation }}
        </div>
      </div>
      <div class="incorrect_icon" />
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/local/business-profile/citations"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          v-if="widget.editable"
          class="btn btn_sm btn-info"
          @click="$parent.edit(widget)"
        >
          Options
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>

    <div
      v-if="!loading && citations.length > 0"
      class="citation_items"
    >
      <div
        v-for="(citation, index) in citations"
        :key="index"
        class="citation_item"
      >
        <img
          :alt="citation.source"
          :src="citation.citation_image"
        >
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div
        v-if="loading && !error"
        class="loading_widget_data"
      >
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>

      <div
        v-else-if="error"
        class="widget_error"
        v-html="error"
      />

      <div v-else>
        No incorrect citations
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';

export default {
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      citations: [],
      error: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview', 'gmbLocations']),
    selectedLocation() {
      return this.gmbLocations[this.widget.location_id];
    }
  },
  watch: {
    'widget.location_id': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'incorrectCitations',
        location_id: this.widget.location_id,
        uuid: this.uuid
      }).then(response => {
        this.citations = response.data;
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    }
  },
}
</script>

<style scoped>
.citations_list {
  height: 100%;
  padding-bottom: 0;
}

.citation_items {
  display: flex;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
  margin: auto 0;
}

.citation_item {
  width: 25%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: .5rem;
}

.citation_item img {
  align-self: stretch;
  border-radius: 0.75rem;
  border: 1px solid #E8E5E2;
}

.incorrect_icon {
  background-color: #FFD673;
  background-image: url("data:image/svg+xml,%3Csvg width='4' height='20' viewBox='0 0 4 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2 2V11.3333' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2 19.3333C3.10457 19.3333 4 18.4379 4 17.3333C4 16.2287 3.10457 15.3333 2 15.3333C0.89543 15.3333 0 16.2287 0 17.3333C0 18.4379 0.89543 19.3333 2 19.3333Z' fill='white'/%3E%3C/svg%3E%0A");
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: auto;
  margin-left: 0.5rem;
  align-self: flex-start;
}

.no_citations {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  font-weight: 700;
}
</style>
